module.exports = __webpack_public_path__ + "img/踩.40bb083c.svg";